import React, {useEffect, useState} from 'react';
import { useAuth } from "../../services/AuthProvider";
import { useNavigate } from "react-router-dom";
import {Box, Input, Typography} from "@mui/material";
import { resetPassword } from "../../services/HttpService";
import { useError } from "../../services/ErrorContext";
import styles from "../Login/Login.module.css";
import KeyIcon from "../../resources/Login/key.png";
import {EmailPattern, UsernamePattern} from "../../services/Util";
import CloseIcon from "@mui/icons-material/Close";
import SpinnerModal from "../../components/Modal/Spinner";

const ForgotPassword: React.FC = () => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const [isBannerOpen, setIsBannerOpen] = useState<boolean>(false);
  const { setError } = useError();
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/dashboard');
    }
  }, [isLoggedIn, navigate]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const username = (event.target as any).username.value;
    if (!UsernamePattern.test(username) && !EmailPattern.test(username)) {
      setError("Please check the username.");
    } else {
      try {
        setShowSpinner(true);
        await resetPassword(username);
        setShowSpinner(false);
        navigate('/check_your_email');
      } catch (error: any) {
        // From Derek:
        // If it's email format, find user by email
        //    Found
        //        Habits user -> 403
        //        Non habits user -> 400
        // If it's not email format, find user by username
        //    Not found -> 404
        setShowSpinner(false);
        if (error.message.indexOf("403") > 0 &&
          error.message.indexOf("HABITs user shouldn") > 0 &&
          error.message.indexOf("t reset password on SPARX") > 0) {
          setIsBannerOpen(true);
        } else if (error.message.indexOf("400") > 0 && EmailPattern.test(username)) {
          setError("Please input your username instead of email address.");
        } else if (error.message.indexOf("404") > 0) {
          setError("This username has not registered in SPARX, please check it and try again.");
        } else {
          setError(error.message);
        }
      }
    }
  };

  return (
    <div className={styles.Login} data-testid="forget-password">
      <SpinnerModal open={showSpinner} />

      <section id="ForgotPasswordTitle" className={styles.LoginTitle}>
        <Typography variant="h1">Reset your password</Typography>
      </section>

      {
        isBannerOpen && <div className={styles.LoginBanner}>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <div>If you have logged into SPARX with your HABITs account, please reset your password using this link: <a href="https://habits-research.co.nz/account/reset/request" style={{color: '#843534', fontWeight: '500'}}>https://habits-research.co.nz/account/reset/request</a>.</div>
          </div>
          <CloseIcon onClick={() => setIsBannerOpen(false)}/>
        </div>
      }

      <br/><br/><br/>
      <Box component="form" onSubmit={handleSubmit} sx={{ width: '80%', maxWidth: 500, textAlign: 'center' }}>
        <img src={KeyIcon} alt="key"/>
        <br/><br/>
        <Typography variant="h3" gutterBottom>Forgot password?</Typography>
        <br/>
        <Typography variant="caption" gutterBottom>No worries, we’ll send you the reset instructions.</Typography>
        <br/><br/><br/>

        {/* Username Field */}
        <Box sx={{ marginBottom: 1 }}>
          <Typography variant="subtitle2" gutterBottom sx={{textAlign: 'left'}}>Username</Typography>
          <Input name="username" fullWidth disableUnderline placeholder="Enter your username"/>
        </Box>

        <button className={`PrimaryButton ${styles.LoginButton}`}>Reset password</button>
      </Box>
    </div>
  );
};

export default ForgotPassword;
